const getValueOrDefault = (value?: string, defaultIfNotFound = "-") => {
  return value || defaultIfNotFound;
};

export { getValueOrDefault };
